import type { Deploy } from '@/payload-types';

export const fetchDeploys = async (tenantId: string): Promise<Deploy[]> => {
  const res = await fetch(`/api/deploys?where[tenant][equals]=${tenantId}&limit=50&depth=0`);
  const { docs = [] } = await res.json();
  return docs as Deploy[];
};
